// extracted by mini-css-extract-plugin
export default {"overlay":"Popup-module__overlay__T1yJq"};